import React, { useState, useEffect, useRef } from 'react';
import { FiFile, FiUploadCloud, FiTrash } from 'react-icons/fi';
import BaseForm from "../../app/components/BaseForm";
import {nomeSchema} from '../../Validations/schemas'
import { z } from 'zod';
import Input from "../../app/components/Input";
import Select from "../../app/components/Select";
import Button from "../../app/components/Button";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;


const TakeFilesEdit = ({ isOpen, onClose, title, onSubmit, initialData }) => {
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});

  const obrigationsOptions = [
        {value: '1', label: 'Consulta fiscal grupo 1'},
        {value: '2', label: '13° Salário - 1° Parcela'},
        {value: '3', label: '13° Salário - 2° Parcela'},
        {value: '4', label: 'Alvará de funcionamento'},
        {value: '5', label: 'Apuração lucro presumido - comércio'},
        {value: '6', label: 'Apuração lucro presumido - comércio/serviço'},
        {value: '7', label: 'Apuração lucro presumido - serviço'},
        {value: '8', label: 'Folha de pagamento'},
  ]

  const destinyOpitions = [
        {value: '1', label: 'Enacaminhamento exames e DP - ASO'},
        {value: '2', label: 'Formulário inicial - Anexe seu curriculo'},
        {value: '3', label: 'Proposta aceita - Envie seus documentos: excluir'},
        {value: '4', label: 'Proposta aceita - Anexe RG ou CNH em PDF'},
        {value: '5', label: 'Proposta aceita - Anexe seu currículo em PDF'},
  ]

  const [formData, setFormData] = useState({
    nome: '',
    sequencia: '',
    tipo_identificacao: '',
  });

  const [rules, setRules] = useState([{ before: '', type: '', after: '' }]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [pdfText, setPdfText] = useState('');
  const [isExtracting, setIsExtracting] = useState(false);

  useEffect(() => {
  if (!isOpen) return;

  if (initialData) {
    setFormData({
      nome: initialData.nome || '',
      sequencia: initialData.sequencia || '',
      tipo_identificacao: initialData.tipo_identificacao || '',
      nome_pasta: initialData.nome_pasta || '',
      obrigacao: initialData.obrigacao || '',
      campo_destino: initialData.campo_destino || '',
    });
    setRules(initialData.regras_identificacao || [{ before: '', type: '', after: '' }]);
    setPdfText(initialData.pdfText || '');
    setSelectedFile(initialData.file || null);
  } else {
    setFormData({
      nome: '',
      sequencia: '',
      tipo_identificacao: '',
      nome_pasta: '',
      obrigacao: '',
      campo_destino: '',
    });
    setRules([{ before: '', type: '', after: '' }]);
    setPdfText('');
    setSelectedFile(null);
  }
}, [isOpen, initialData]);


  const handleChange = (eOrValue, fieldName) => {
    let name, value;

    if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
      name = fieldName;
      value = eOrValue.value;
    } else {
      name = eOrValue.target.name;
      value = eOrValue.target.value;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'nome') {
      if (typeof value === 'string' && value.trim() === '') {
        setErrors((prev) => ({ ...prev, nome: '' }));
        return;
      }

      try {
        nomeSchema.parse(value);
        setErrors((prev) => ({ ...prev, nome: '' }));
      } catch (err) {
        if (err instanceof z.ZodError) {
          setErrors((prev) => ({ ...prev, nome: err.errors[0].message }));
        }
      }
    }
  };



  const handleAddRule = () => {
    setRules(prev => [...prev, { before: '', type: '', after: '' }]);
  };

  const handleRemoveRule = (index) => {
    if (index !== 0) {
      setRules(prev => prev.filter((_, i) => i !== index));
    }
  };

  const handleRuleChange = (index, field, value) => {
    setRules(prevRules =>
      prevRules.map((rule, i) =>
        i === index ? { ...rule, [field]: value } : rule
      )
    );
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setIsExtracting(true);
      setSelectedFile(file);
      const fileReader = new FileReader();

      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);

        try {
          const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
          let fullText = '';

          for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            const textContent = await page.getTextContent();
            const pageText = textContent.items.map(item => item.str).join(' ');
            fullText += pageText + '\n';
          }

          setPdfText(fullText);
        } catch (err) {
          console.error('Erro ao extrair o texto do PDF:', err);
        } finally {
          setIsExtracting(false);
        }
      };

      fileReader.readAsArrayBuffer(file);
    } else {
      alert('Por favor, selecione um arquivo PDF válido.');
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      const formattedData = {
        ...formData,
        regras_identificacao: rules,
        file: selectedFile,
      };
      onSubmit(formattedData);
    }
  };

  const sequenceOptionsTakeFiles = [
    { value: '1', label: 'Banco de Talentos - Departamento:RH' },
    { value: '2', label: 'Controle de Atualização - Desenvolvimento' },
    { value: '3', label: 'Controle de Desenvolvimento - Desenvolvimento' },
  ];

  const ruleOptions = [
    { value: '1', label: 'CNPJ' },
    { value: '2', label: 'CPF' },
  ];

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      className='max-w-4xl'
    >
      <div className="grid grid-cols-3 gap-4 m-4">
        <div className="col-span-3">
          <input
            type="file"
            accept="application/pdf"
            ref={fileInputRef}
            onChange={handleFileSelect}
            className="hidden"
          />

          {!pdfText && (
            <div
              className={`border-2 border-dashed ${selectedFile ? 'border-[#a04ccb]' : 'border-gray-300'} rounded-xl p-6 text-center cursor-pointer hover:bg-gray-50 transition`}
              onClick={triggerFileInput}
            >
              {isExtracting ? (
                <p className="text-sm text-gray-500">Extraindo texto do PDF...</p>
              ) : selectedFile ? (
                <div className="flex flex-col items-center">
                  <div className="flex items-center justify-center mb-2 w-12 h-12 rounded-full bg-blue-100 text-[#a04ccb]">
                    <FiFile size={24} />
                  </div>
                  <p className="text-sm font-medium text-gray-700">{selectedFile.name}</p>
                  <p className="text-xs text-gray-500">
                    {(selectedFile.size / 1024).toFixed(2)} KB
                  </p>
                </div>
              ) : (
                <div>
                  <FiUploadCloud size={40} className="text-gray-300 mx-auto mb-2" />
                  <p className="text-sm text-gray-400">Clique aqui para selecionar um PDF</p>
                </div>
              )}
            </div>
          )}

          {pdfText && (
            <div className="border rounded-xl p-4 whitespace-pre-wrap max-h-96 overflow-y-auto bg-gray-50">
              {pdfText}
            </div>
          )}
        </div>

        <div className="col-span-3">
          <div>
          <Input
            label="Nome do Arquivo"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            error={errors.nome}
          />
          {errors.nome && (
            <p className="text-red-500 text-sm mt-[-0.95rem]">{errors.nome}</p>
          )}
          </div>
          <Select
            name="obrigacao"
            label="Selecione a obrigação"
            options={obrigationsOptions}
            value={formData.obrigacao}
            onChange={handleChange}
            className="mt-2 mb-8"
          />
          <Select
            name="sequencia"
            label="Selecione a sequencia"
            options={sequenceOptionsTakeFiles}
            value={formData.sequencia}
            onChange={handleChange}
            className="mt-2 mb-8"
          />
          <Select
            name="campo_destino"
            label="Campo de destino (Anexo)"
            options={destinyOpitions}
            value={formData.campo_destino}
            onChange={handleChange}
            className="mt-2 mb-8"
          />
          <Input
            name="nome_pasta"
            className="mt-2 mb-8"
            label={'Nome da Pasta (AWS)'}
            value={formData.nome_pasta}
            onChange={handleChange}
          />
          <Input
            name="tipo_identificacao"
            className="mt-2 mb-8"
            label={'Tipo de Identificação'}
            value={formData.tipo_identificacao}
            onChange={handleChange}
          />

          <div className="mt-6">
            <div className="flex justify-between items-center mb-2">
              <h1>Regras de Identificação</h1>
              <Button variant="secondary" className="!font-normal" onClick={handleAddRule}>
                Adicionar regra
              </Button>
            </div>

            {rules.map((rule, index) => (
              <div key={index} className="grid grid-cols-3 gap-4 items-center mt-3 relative">
                <Input
                  label="Texto antes"
                  value={rule.before}
                  onChange={(e) => handleRuleChange(index, 'before', e.target.value)}
                />
                <Select
                  label="Selecione"
                  options={ruleOptions}
                  value={rule.type}
                  onChange={(e) => handleRuleChange(index, 'type', e.target.value)}
                />
                <Input
                  label="Texto depois"
                  value={rule.after}
                  onChange={(e) => handleRuleChange(index, 'after', e.target.value)}
                />

                {index !== 0 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveRule(index)}
                    className="absolute bg-white -top-1 -right-1 text-red-500 text-sm"
                  >
                  <FiTrash/>
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </BaseForm>
  );
};

export default TakeFilesEdit;
